import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router'
import WidgetsSignInForm from './form'
import {logAnalytics, EVENT_TYPES} from 'logAnalytics'


function WidgetsSignIn(props) {
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        document.title = 'Math Makers Sign In'

        logAnalytics(EVENT_TYPES.PAGE_VIEW, {page: document.title})

        setMounted(true)
    }, [])

    if (!mounted)
        return <></>

    return (
        <>
            <div className='hero-bg'>
                <div className='form-container'>
                    <WidgetsSignInForm />
                </div>
            </div>
        </>
    )
}

export default withRouter(WidgetsSignIn)